/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notes': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M16.76 18.489H6.59a1.924 1.924 0 01-1.907-1.907V3.352c0-.867.694-1.619 1.618-1.619H16.76c1.04 0 1.907.867 1.907 1.907v12.884c0 1.098-.867 1.965-1.907 1.965zM6.302 2.947a.497.497 0 00-.462.462v13.173c0 .405.347.751.751.751H16.76a.765.765 0 00.751-.75V3.64a.765.765 0 00-.751-.751H6.302v.058zM2.49 17.91a.579.579 0 01-.578.578c-.289 0-.578-.289-.578-.578V6.933c0-.346.29-.577.578-.577.289 0 .578.289.578.577v10.978zM7.747 7.05c0 .289.23.578.577.578h3.583a.579.579 0 000-1.156H8.324a.579.579 0 00-.577.578zm.577 3.64a.579.579 0 01-.577-.578c0-.289.288-.578.577-.578h5.72c.347 0 .578.29.578.578 0 .29-.289.578-.578.578h-5.72zm0 3.062a.579.579 0 010-1.156h5.72a.579.579 0 010 1.156h-5.72z" _fill="#1D3861"/>'
  }
})
